export default {
    setAlias(param) {

    },
    removeAlias(param) {
    },
    getAllMessage(callback) {
        callback([])
    }
}